import "./Footer.css";

function Footer() {
  return (

    <footer className="footer">

      <p>
        © 2026 EcoDrop — Share smarter. Live greener.
      </p>

    </footer>

  );
}

export default Footer;